export default __webpack_public_path__ + "static/media/chevron_up.2f25f0d3.svg";